// All API endpoint path strings in one place.
// Import this wherever an HTTP call is made — never hard-code paths inline.
const BASE = (process.env.REACT_APP_API_BASE_URL ?? '').replace(/\/$/, '');

export const API_URLS = {
  validateToken:    `${BASE}/api/token/validate`,
  validateIdentity: `${BASE}/api/validate-identity`,
  captcha:          `${BASE}/api/captcha`,
  generateForm:     `${BASE}/api/form-access`,
  downloadPdf:      `${BASE}/api/download`,
  legalDocument:    (typeId: number) => `${BASE}/api/legal/document/${typeId}`,
} as const;
